<div class="cursor-pointer" [ngClass]="{ 'px-sm py-base': !contentSlot.children.length }">
  <div #contentSlot (click)="filterMenuTrigger.openMenu()">
    <ng-content></ng-content>
  </div>
  @if (!contentSlot.children.length) {
    <div
      class="min-w-max flex items-center text-base leading-base text-txt"
      [ngClass]="{
        '!text-primary': filter && filter.items && filter.items.length > 0,
        'justify-end pr-sm': rightAlign
      }"
      (click)="
        !onlySort
          ? filterMenuTrigger.openMenu()
          : filterChanged.emit({
              sort: {
                active: filter.key,
                direction: !sort || !sort.direction ? 'desc' : sort.direction === 'desc' ? 'asc' : ''
              }
            })
      "
    >
      <span>
        {{ filter.label }}
      </span>
      @if (sortDirection) {
        <div
          class="ml-sm flex text-txt-secondary"
          [ngClass]="{ 'rotate-180': sortDirection === 'desc' }"
        >
          @if (sortDirection) {
            <svg-icon key="arrow-up-full" class="!text-xs"></svg-icon>
          }
        </div>
      }
    </div>
  }
  <div
    [matMenuTriggerFor]="filterMenu"
    #filterMenuTrigger="matMenuTrigger"
    (onMenuOpen)="focusOnInput()"
  ></div>
</div>

<mat-menu #filterMenu="matMenu" [hasBackdrop]="true" class="mg-filter-menu" (closed)="onMenuClose()">
  <div [id]="filter.key + 'filtertop'"></div>
  <div
    class="relative p-base pb-0 flex flex-col w-[340px] beautyScroll"
    [ngClass]="{
      'md:!w-[450px]': filter.columnType === tableColumnTypes.date,
      '!max-h-[450px]': filter.columnType === tableColumnTypes.checkbox
    }"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    @if (!filter.hideSorting) {
      <div class="flex items-center">
        <div
          class="sort-btn mr-sm"
          [ngClass]="{ 'sort-btn-active': sortDirection === 'asc' }"
          (click)="
            filterChanged.emit({
              sort:
                sort?.active === filter.key && sort?.direction === 'asc'
                  ? null
                  : { active: filter.key, direction: 'asc' }
            })
          "
        >
          {{ filter.columnType === tableColumnTypes.number ? 'Low to high' : 'Ascending' }}
        </div>
        <div
          class="sort-btn"
          [ngClass]="{ 'sort-btn-active': sortDirection === 'desc' }"
          (click)="
            filterChanged.emit({
              sort:
                sort?.active === filter.key && sort?.direction === 'desc'
                  ? null
                  : { active: filter.key, direction: 'desc' }
            })
          "
        >
          {{ filter.columnType === tableColumnTypes.number ? 'High to low' : 'Descending' }}
        </div>
      </div>
    }

    <form [formGroup]="form" (ngSubmit)="submit()">
      <!-- Aggregator -->
      @if (
        isAdvancedMode &&
        (filter.columnType === tableColumnTypes.text || filter.columnType === tableColumnTypes.number)
      ) {
        <mg-dropdown-menu
          class="block my-sm w-full"
          [fullWidth]="true"
          [items]="aggregatorItems"
          [selectedItem]="form.get('aggregator')?.value"
          (selectedItemChanged)="form.get('aggregator')?.setValue($event)"
        >
        </mg-dropdown-menu>
      }

      @if (filter.searchable && filter.columnType === tableColumnTypes.checkbox) {
        <mg-input
          class="block mb-xs"
          controlName="searchText"
          size="small"
          label="Search"
          icon="search"
          [normalInputId]="filter.key + 'input'"
        ></mg-input>
      }
      @for (
        itemForm of $any(itemsControl['controls']);
        track itemForm.get('ruleId')?.value;
        let i = $index
      ) {
        <div formArrayName="items">
          <ng-container [formGroup]="itemForm">
            @switch (filter.columnType) {
              @case (tableColumnTypes.checkbox) {
                <div class="flex flex-col gap-sm" [ngClass]="{ 'mt-base': !filter.searchable }">
                  @for (item of visibleListItems; track item) {
                    <div class="flex items-center cursor-pointer">
                      <mg-checkbox
                        [item]="item"
                        labelClass="!text-base !text-txt"
                        controlName="value"
                      ></mg-checkbox>
                    </div>
                  }
                </div>
              }
              @case (tableColumnTypes.radio) {
                <div class="mt-base flex flex-col gap-sm">
                  @for (item of filter.listItems ?? []; track item) {
                    <div class="flex items-center cursor-pointer">
                      <mg-radio
                        [item]="item"
                        labelClass="!text-base !text-txt"
                        [circleSize]="18"
                        controlName="value"
                      ></mg-radio>
                    </div>
                  }
                </div>
              }
              @case (tableColumnTypes.date) {
                <mg-range-date-picker
                  class="block mt-base"
                  [standalone]="true"
                  [value]="selectedDateInfo"
                  maxDate="Today"
                  (valueChanged)="
                    onDateChange(false, itemForm.get('value'), itemForm.get('extraValue'), $event)
                  "
                  (initailValueChanged)="
                    onDateChange(true, itemForm.get('value'), itemForm.get('extraValue'), $event)
                  "
                ></mg-range-date-picker>
              }
              @default {
                <div class="flex -mt-sm">
                  @if (filter.columnType === tableColumnTypes.number || isAdvancedMode) {
                    <mg-dropdown-menu
                      class="mr-sm mt-sm"
                      extraClass="!py-[7px]"
                      [items]="operators"
                      [selectedItem]="itemForm.get('operator')?.value"
                      (selectedItemChanged)="itemForm.get('operator')?.setValue($event)"
                    >
                    </mg-dropdown-menu>
                  }
                  <mg-input
                    class="flex-1"
                    controlName="value"
                    [type]="$any(filter.columnType)"
                    size="small"
                    placeholder="Value"
                    [normalInputId]="filter.key + 'input'"
                  ></mg-input>
                  @if (isAdvancedMode) {
                    <div
                      class="flex ml-sm pt-xl text-txt-disabled hover:text-txt cursor-pointer"
                      (click)="removeRule(i)"
                    >
                      <svg-icon key="close" class="!text-sm"></svg-icon>
                    </div>
                  }
                </div>
              }
            }
          </ng-container>
        </div>
      }

      <!-- Add new rule -->
      @if (
        isAdvancedMode &&
        (filter.columnType === tableColumnTypes.text || filter.columnType === tableColumnTypes.number)
      ) {
        <div class="my-xs flex">
          <mg-button
            type="button"
            size="small-shrink"
            variant="ghost"
            icon="plus"
            (click)="addNewRule()"
          >
            Add rule
          </mg-button>
        </div>
      }
    </form>

    <div
      class="sticky z-50 bg-white left-0 bottom-0 pb-base pt-base flex items-center justify-between"
      [ngClass]="{
        '!pt-xs':
          filter.columnType === tableColumnTypes.number || filter.columnType === tableColumnTypes.text
      }"
    >
      <mg-button
        extraBtnClass="!p-0 !text-txt-secondary"
        variant="ghost"
        size="small"
        (click)="
          filterMenuTrigger.closeMenu();
          filterChanged.emit({
            shouldDelete: true
          })
        "
      >
        Clear
      </mg-button>

      <mg-button extraBtnClass="!p-0" variant="ghost" size="small" (click)="submit()">Filter</mg-button>
    </div>
  </div>
</mat-menu>
